import styled from "styled-components";
import { Link } from "react-router-dom";

const CustomButton = styled.button`
  padding: 5px;
  width: 120px;
  height: 40px;
  cursor: pointer;
  white-space: nowrap;
`;

const FilledButton = styled(CustomButton)`
  border: none;
  background-color: var(--color-main);
  color: var(--color-white);

  ${({ disabled }) =>
    disabled &&
    `
    background-color: var(--color-gray);
    color: var(--color-white);
    cursor: not-allowed;
  `}
`;

const OutlinedButton = styled(CustomButton)`
  border: 1px solid var(--color-main);
  background-color: var(--color-white);
  color: var(--color-main);
`;

const TextButton = styled(CustomButton)`
  width: auto;
  border: none;
  background-color: transparent;
  color: var(--color-blue);
  font-size: var(--font-size-medium);
`;

const CustomLink = styled(Link)`
  padding: 5px;
  width: 100%;
  height: 40px;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  margin: 0;
`;

const FilledLink = styled(CustomLink)`
  border: none;
  background-color: var(--color-main);
  color: var(--color-white);
`;

const OutlinedLink = styled(CustomLink)`
  border: 1px solid var(--color-main);
  background-color: var(--color-white);
  color: var(--color-main);
`;

const TextLink = styled(CustomLink)`
  width: auto;
  height: auto;
  border: none;
  background-color: transparent;
  color: var(--color-blue);
  font-size: var(--font-size-medium);
`;

const TablePageButton = ({ totalPage, currentPage, setCurrentPage }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "10px",
      }}
    >
      {Array.from({ length: totalPage }, (_, index) => (
        <OutlinedButton
          style={{
            width: "30px",
            height: "30px",
            backgroundColor:
              currentPage === index + 1
                ? "var(--color-main)"
                : "var(--color-white)",
            color:
              currentPage === index + 1
                ? "var(--color-white)"
                : "var(--color-black)",
          }}
          onClick={() => {
            setCurrentPage(index + 1);
          }}
        >
          {index + 1}
        </OutlinedButton>
      ))}
    </div>
  );
};

export {
  CustomButton,
  FilledButton,
  OutlinedButton,
  TextButton,
  CustomLink,
  FilledLink,
  OutlinedLink,
  TextLink,
  TablePageButton,
};
